import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React from 'react';

import { Box, Flex, Text } from '~/components/blocks';
import { PatientTypeIcon } from '~/components/partials';

type Props = {
  hasApp?: boolean | false;
  phoneNumber?: string | null;
  hasLine?: boolean | false;
};

const Content = styled(Flex)(({ theme }) =>
  css({
    backgroundColor: theme.colors.background.bg,
    borderRadius: theme.radii.half,
    padding: `${theme.space.xs} ${theme.space.m}`,
    height: '100%',
    width: 'fit-content',
    textAlign: 'center',
  }),
);

export const ContactMethod = (props: Props) => {
  const { hasApp, phoneNumber, hasLine } = props;
  const theme = useTheme();

  return (
    <Box>
      {hasApp && (
        <Content alignItems="center" marginBottom={phoneNumber || hasLine ? theme.space.s : 0}>
          <PatientTypeIcon isPatient={true} size="l" />
          <Text size="s">アプリ</Text>
        </Content>
      )}
      {hasLine && (
        <Content alignItems="center" marginBottom={phoneNumber ? theme.space.s : 0}>
          <PatientTypeIcon isLine={true} size="l" />
          <Text size="s">LINE</Text>
        </Content>
      )}
      {phoneNumber && (
        <Content alignItems="center">
          <PatientTypeIcon isPatient={false} size="l" />
          <Text size="s">{phoneNumber}</Text>
        </Content>
      )}
    </Box>
  );
};
